// extracted by mini-css-extract-plugin
export var menuIcon = "_o6-0";
export var menuIconInline = "_o6-1";